import { Article } from '../../types'

export const MOCK_GENERAL_ARTICLES: Article[] = [
  {
    source: {
      name: 'CNBC',
    },
    title: 'CPI inflation February 2023: - CNBC',
    author: 'Jeff Cox',
    url: 'https://www.cnbc.com/2023/03/14/cpi-inflation-february-2023-.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107195792-16765636862023-02-16t151931z_117200947_rc2ecz937tqu_rtrmadp_0_usa-eggs-antitrust.jpeg?v=1678797082&w=1920&h=1080',
    publishedAt: '2023-03-14T12:31:22Z',
  },
  {
    source: {
      name: 'CBS News',
    },
    title:
      'Submarine with 2 bodies, 3 tons of cocaine seized in the Pacific Ocean off Colombia - CBS News',
    author: 'Stephen Smith',
    url: 'https://www.cbsnews.com/news/submarine-2-bodies-3-tons-cocaine-seized-colombia-navy/',
    urlToImage:
      'https://assets3.cbsnewsstatic.com/hub/i/r/2023/03/14/e8af710f-0851-46d3-840f-8971841ba9b7/thumbnail/1200x630g8/ae72d6687ec2ab2bb30b9d2289d9bc9e/sub.jpg',
    publishedAt: '2023-03-14T11:48:51Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: "NFL free agency: Who's going where and what to expect - CNN",
    author: 'Ben Morse',
    url: 'https://www.cnn.com/2023/03/14/sport/nfl-free-agency-preview-2023-spt-intl/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313115617-aaron-rodgers-lamar-jackson-split-restricted.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T11:29:00Z',
  },
  {
    source: {
      name: 'Yahoo Entertainment',
    },
    title:
      'March Madness 2023: NCAA tournament printable brackets, dates, times and more - Yahoo Sports',
    author: 'Ryan Young',
    url: 'https://sports.yahoo.com/march-madness-2023-ncaa-basketball-tournament-printable-brackets-dates-times-and-more-112340630.html',
    urlToImage:
      'https://s.yimg.com/os/creatr-uploaded-images/2023-03/d485be51-c12c-11ed-9f3f-148c8b08a5d9',
    publishedAt: '2023-03-14T11:23:40Z',
  },
  {
    source: {
      name: 'Page Six',
    },
    title:
      "Andy Cohen issues PSA for upcoming 'Pump Rules' episode: 'You won't believe it' - Page Six",
    author: 'Nika Shakhnazarova',
    url: 'https://pagesix.com/2023/03/14/andy-cohen-issues-psa-for-upcoming-pump-rules-episode/',
    urlToImage:
      'https://pagesix.com/wp-content/uploads/sites/3/2023/03/andy-cohen-raquel-leviss-tom-sandoval-ariana-madix-48.jpg?quality=75&strip=all&w=1200',
    publishedAt: '2023-03-14T11:08:00Z',
  },
  {
    source: {
      name: 'CNBC',
    },
    title:
      'First Republic shares jump 40% as regional banks try to rebound from Monday’s sell-off - CNBC',
    author: 'Jesse Pound, Fred Imbert',
    url: 'https://www.cnbc.com/2023/03/14/first-republic-shares-jump-as-regional-banks-try-to-rebound-from-mondays-selloff.html',
    urlToImage:
      'https://image.cnbcfm.com/api/v1/image/107207471-1678710077938-gettyimages-1247997034-FIRST_REPUBLIC_BANK.jpeg?v=1678791818&w=1920&h=1080',
    publishedAt: '2023-03-14T11:03:38Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title:
      "Credit Suisse finds 'material weakness' in its financial reporting, scraps exec bonuses - CNN",
    author: 'Hanna Ziady',
    url: 'https://www.cnn.com/2023/03/14/investing/credit-suisse-financial-reporting-weakness/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230314090127-credit-suisse-file-111722.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T10:49:00Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title:
      'Trump rails against probes as he posts videos complaining about DeSantis and defending Kim Jong Un - The Independent',
    author: 'Eric Garcia',
    url: 'https://www.independent.co.uk/news/world/americas/us-politics/trump-desantis-iowa-kim-jong-un-b2300413.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/13/21/GettyImages-1471924602.jpg?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T10:38:11Z',
  },
  {
    source: {
      name: 'Ct.gov',
    },
    title:
      'Governor Lamont Orders Executive Branch State Office Buildings Closed to the Public Tuesday Due to Winter Storm - CT.gov',
    author: null,
    url: 'https://portal.ct.gov/Office-of-the-Governor/News/Press-Releases/2023/03-2023/Governor-Lamont-Orders-Executive-Branch-State-Office-Buildings-Closed-to-the-Public-Tuesday',
    urlToImage: 'https://portal.ct.gov/Assets/Images/facebook-default_01.png',
    publishedAt: '2023-03-14T10:14:25Z',
  },
  {
    source: {
      name: 'NDTV News',
    },
    title:
      'This Hollywood Star "Literally Gasped" When Natasha Poonawalla Passed By At Vanity Fair Party - NDTV Movies',
    author: null,
    url: 'https://www.ndtv.com/entertainment/on-natasha-poonawalla-s-oscar-after-party-look-ariana-debose-said-this-3859267',
    urlToImage:
      'https://c.ndtvimg.com/2023-03/g09cjdp8_natasha-_625x300_14_March_23.jpg',
    publishedAt: '2023-03-14T10:08:00Z',
  },
  {
    source: {
      name: 'Daily Beast',
    },
    title:
      "Huliapole in Southern Ukraine Braces for 'Decisive' Counteroffensive on Russian Forces - The Daily Beast",
    author: 'Sam Skove',
    url: 'https://www.thedailybeast.com/huliapole-in-southern-ukraine-braces-for-decisive-counteroffensive-on-russian-forces',
    urlToImage:
      'https://img.thedailybeast.com/image/upload/c_crop,d_placeholder_euli9k,h_675,w_1200,x_0,y_0/dpr_2.0/c_limit,w_740/fl_lossy,q_auto/v1678760356/041423-skove-ukrainer-hero_dr7u8i',
    publishedAt: '2023-03-14T09:41:02Z',
  },
  {
    source: {
      name: 'Bloomberg',
    },
    title:
      'Global Financial Stocks Lose $465 Billion on SVB Collapse, Contagion Fears - Bloomberg',
    author: 'Kurt Schussler',
    url: 'https://www.bloomberg.com/news/articles/2023-03-14/global-financial-stocks-lose-465-billion-on-svb-impact-worry',
    urlToImage:
      'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iPMzX7z8eXaQ/v0/1200x800.jpg',
    publishedAt: '2023-03-14T09:38:46Z',
  },
  {
    source: {
      name: 'The Weather Channel',
    },
    title:
      "Nor'easter Brings Heavy Snow, High Winds To East - The Weather Channel",
    author: 'The Weather Channel',
    url: 'https://weather.com/storms/winter/news/2023-03-13-noreaster-forecast-winter-storm-sage-northeast-winter-storm',
    urlToImage: 'https://s.w-x.co/sagetueam.jpg',
    publishedAt: '2023-03-14T09:31:17Z',
  },
  {
    source: {
      name: 'Yahoo Entertainment',
    },
    title: 'Biden to reinforce background checks for gun buyers - Yahoo News',
    author: 'Daniel Trotta',
    url: 'https://news.yahoo.com/biden-reinforce-background-checks-gun-090949876.html',
    urlToImage:
      'https://media.zenfs.com/en/reuters.com/97eb6f85bcb2780ef3e7565bf63b22f9',
    publishedAt: '2023-03-14T09:09:49Z',
  },
  {
    source: {
      name: 'Engadget',
    },
    title:
      "Sennheiser's 'Profile' microphone for streamers gets a lot right - Engadget",
    author: 'https://www.engadget.com/about/editors/james-trew',
    url: 'https://www.engadget.com/sennheisers-profile-microphone-for-streamers-gets-a-lot-right-090017043.html',
    urlToImage:
      'https://s.yimg.com/uu/api/res/1.2/fHQMJOSFLpiVYVEfV2QKag--~B/Zmk9ZmlsbDtoPTYzMDtweW9mZj0wO3c9MTIwMDthcHBpZD15dGFjaHlvbg--/https://media-mbst-pub-ue1.s3.amazonaws.com/creatr-uploaded-images/2023-03/91aee5f0-c264-11ed-877d-c62c54c26d20.cf.jpg',
    publishedAt: '2023-03-14T09:02:13Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: 'Biden says Carter asked him to deliver his eulogy - CNN',
    author: 'Donald Judd',
    url: 'https://www.cnn.com/2023/03/14/politics/jimmy-carter-eulogy-biden/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313235622-jimmy-carter-joe-biden-031323.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T07:02:00Z',
  },
  {
    source: {
      name: 'Reuters',
    },
    title:
      'Eyeing China, Biden and allies unveil nuclear-powered submarine plan for Australia - Reuters',
    author: null,
    url: 'https://www.reuters.com/world/eyeing-china-biden-allies-unveil-nuclear-powered-submarine-plan-australia-2023-03-13/',
    urlToImage:
      'https://www.reuters.com/resizer/nNmxxvIlWLg_G0dSQ1_oRh3Pn_g=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/4FQOKL3JXJNALOSSGZV5KG6LQQ.jpg',
    publishedAt: '2023-03-14T06:07:00Z',
  },
  {
    source: {
      name: 'Reuters',
    },
    title:
      "Learning from Ukraine, Taiwan shows off its drones as key to 'asymmetric warfare' - Reuters",
    author: null,
    url: 'https://www.reuters.com/world/asia-pacific/learning-ukraine-taiwan-shows-off-its-drones-key-asymmetric-warfare-2023-03-14/',
    urlToImage:
      'https://www.reuters.com/resizer/r67mJnbcP5PeVW_Bp1Tb0KfLZLE=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/YYIMG6Y7NZIPZD7APQRV32KBZA.jpg',
    publishedAt: '2023-03-14T05:49:00Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'Piers Morgan mocks Angela Bassett who didn’t ‘get the memo’ at Oscars - youtube.com',
    author: null,
    url: 'https://www.youtube.com/watch?v=2erNjXAKJAM',
    urlToImage: 'https://i.ytimg.com/vi/2erNjXAKJAM/maxresdefault.jpg',
    publishedAt: '2023-03-14T05:15:44Z',
  },
  {
    source: {
      name: 'The Guardian',
    },
    title:
      'Silicon Valley Bank: parent company, CEO and CFO sued amid market turmoil - The Guardian',
    author: 'Guardian staff reporter',
    url: 'https://www.theguardian.com/business/2023/mar/14/silicon-valley-bank-lawsuit-fraud-shareholders',
    urlToImage:
      'https://i.guim.co.uk/img/media/21ffee6606f9bed849bbd3eb032f68172a456426/0_24_4000_2400/master/4000.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=f39eb54f3d29fed75b17585778f2c887',
    publishedAt: '2023-03-14T05:00:00Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      "Former Rep. Pat Schroeder, pioneer for women's rights, dies - 9NEWS",
    author: null,
    url: 'https://www.youtube.com/watch?v=ngtzF5kXmJI',
    urlToImage: 'https://i.ytimg.com/vi/ngtzF5kXmJI/hqdefault.jpg',
    publishedAt: '2023-03-14T04:30:46Z',
  },
  {
    source: {
      name: 'KSL.com',
    },
    title:
      "Family fundraising to save toddler with disorder that turns babies into 'human time bombs' - KSL.com",
    author: 'https://www.facebook.com/kslcom/',
    url: 'https://www.ksl.com/article/50598831/family-fundraising-to-save-toddler-with-disorder-that-turns-babies-into-human-time-bombs',
    urlToImage:
      'https://img.ksl.com/slc/2920/292009/29200931.jpeg?filter=kslv2/responsive_story_lg',
    publishedAt: '2023-03-14T04:08:52Z',
  },
  {
    source: {
      name: 'The Athletic',
    },
    title:
      'Raiders’ free-agent fits: Focus shifts to defense, O-line after adding Jimmy Garoppolo - The Athletic',
    author: 'Tashan Reed',
    url: 'https://theathletic.com/4304893/2023/03/13/raiders-best-remaining-free-agents/',
    urlToImage:
      'https://cdn.theathletic.com/app/uploads/2023/03/13215349/GettyImages-1425625137-1024x683.jpg',
    publishedAt: '2023-03-14T03:33:12Z',
  },
  {
    source: {
      name: 'SciTechDaily',
    },
    title:
      'Sea Monster From Age of Dinosaurs Found on Remote Arctic Island - SciTechDaily',
    author: null,
    url: 'https://scitechdaily.com/?p=260349',
    urlToImage:
      'https://scitechdaily.com/images/Reconstruction-of-Earliest-Ichthyosaur.jpg',
    publishedAt: '2023-03-14T03:15:22Z',
  },
  {
    source: {
      name: 'Variety',
    },
    title:
      'Oscars Show Secrets: Rihanna and Tom Cruise Jokes You Didn’t Hear, the Lady Gaga Saga and Whether Jimmy Kimmel Will Return (EXCLUSIVE) - Variety',
    author: 'Michael Schneider',
    url: 'https://variety.com/2023/tv/news/oscars-lady-gaga-rihanna-jimmy-kimmel-behind-the-scenes-secrets-1235553066/',
    urlToImage:
      'https://variety.com/wp-content/uploads/2023/03/GettyImages-1473097088-e1678751132774.jpg?w=1000&h=563&crop=1',
    publishedAt: '2023-03-14T02:28:00Z',
  },
]
